import React from "react";
import LayoutBase from "./layout_base";
import TopNav from "./top_nav";
import Footer from "./footer";
import classNames from "classnames";
import styles from '../../styles/layout_viewport.module.scss';

interface LayoutViewportProps {
  children: React.ReactNode;
  contentClassName?: string;
}

export default function LayoutViewport({ children, contentClassName }: LayoutViewportProps) {
  return <LayoutBase>
    <div className={styles.box}>
      <div className={classNames(styles.header, styles.row)}>
        <TopNav />
      </div>

      <div className={classNames(styles.row, styles.content, contentClassName)}>
        {children}
      </div>

      <div className={classNames(styles.row, styles.footer)}>
        <Footer />
      </div>
    </div>
  </LayoutBase>
}